<template>
    <div class="loginPage container">
        <div class="login-main">
            <div class="login-info">
                <div class="login-info-inner">
                    <div class="login-title">PM2.5 和O3污染协同防控的工程化模式系统与支撑平台</div>
                    <div class="login-name">大气污染智慧监管和执法技术平台</div>
                    <div class="login-img">
                        <img src="../assets/login-img.png" alt="">
                    </div>
                </div>
            </div>
            <div class="login-content">
                <div class="login-content-inner">
                    <div class="login-wel">欢迎登录</div>
                    <p class="login-sub">请使用帐号密码登录系统</p>
                    <el-form
                        :model="dataForm"
                        :rules="dataRule"
                        ref="dataForm"
                        class="login-form"
                        @keyup.enter.native="dataFormSubmit()"
                        status-icon>
                        <el-form-item prop="username">
                            <div class="form-item">
                                <span class="icon">
                                    <img src="../assets/md-person.svg" alt="">
                                </span>
                                <el-input v-model="dataForm.username" placeholder="帐号" clearable></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password">
                            <div class="form-item">
                                <span class="icon">
                                    <img src="../assets/md-pwd.svg" alt="">
                                </span>
                                <el-input v-model="dataForm.password" type="password" placeholder="密码" show-password></el-input>
                            </div>
                        </el-form-item>
                        <div class="formItem">
                            <el-checkbox v-model="rememberMe">记住密码</el-checkbox>
                        </div>
                        <el-form-item class="login-btn">
                            <el-button class="login-btn-submit" type="primary" @click="dataFormSubmit()">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {login} from "../api";

    export default {
        data() {
            return {
                dataForm: {
                    username: '',
                    password: '',
                },
                rememberMe: false,
                dataRule: {
                    username: [
                        {required: true, message: '帐号不能为空', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'}
                    ]
                },
            }
        },
        computed: {
            ishu: {
                get() {
                    return this.$store.state.user.ishu
                },
                set(val) {
                    this.$store.commit('updateIshu', val)
                }
            }
        },
        created() {
            this.getLocalStorage()
        },

        methods: {
            // 提交表单（与接口文档一致：仅 username、password）
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {

                        if (this.rememberMe) {
                            localStorage.setItem('username', this.dataForm.username)
                            localStorage.setItem('password', this.dataForm.password)
                            localStorage.setItem('rememberMe', this.rememberMe)
                        } else {
                            localStorage.removeItem('username')
                            localStorage.removeItem('password')
                            localStorage.removeItem('rememberMe')
                        }

                        const data = {
                            username: this.dataForm.username,
                            password: this.$md5(this.dataForm.password)
                        }

                        login(data).then(res => {
                            if (res.code === 200) {
                                localStorage.setItem('token', res.data.token)
                                this.ishu = false
                                this.$router.push({name: 'pushmiss'})
                            }
                        })
                    }
                })
            },

            getLocalStorage() {
                const username = localStorage.getItem('username');
                const password = localStorage.getItem('password');
                const rememberMe = localStorage.getItem('rememberMe');
                this.dataForm = {
                    username: username === undefined || username === null ? this.dataForm.username : username,
                    password: password === undefined || password === null ? this.dataForm.password : password,
                };
                this.rememberMe = rememberMe === undefined || rememberMe === null ? false : Boolean(rememberMe)
            },
            forget() {
                this.$message.info('请联系管理员')
            },
            noAccount() {
                this.$message.info('请联系管理员')
            }
        }
    }
</script>

<style lang="less">
    .loginPage {
        min-height: 100%;
        background: linear-gradient(135deg, #e8eefc 0%, #d4e0f7 45%, #c5d4f0 100%);
        background-image: url("../assets/bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        box-sizing: border-box;

        .login-main {
            display: flex;
            align-items: stretch;
            max-width: 960px;
            width: 100%;
            background: #fff;
            border-radius: 16px;
            box-shadow: 0 12px 40px rgba(58, 98, 215, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06);
            overflow: hidden;

            .login-info {
                flex: 0 0 42%;
                min-width: 280px;
                background: linear-gradient(165deg, #4a72e8 0%, #3A62D7 48%, #2d4fbf 100%);
                color: #fff;
                padding: 36px 28px;
                display: flex;
                align-items: center;
                justify-content: center;

                .login-info-inner {
                    width: 100%;
                }

                .login-title {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 1.55;
                    letter-spacing: 0.02em;
                }

                .login-name {
                    margin-top: 14px;
                    font-size: 14px;
                    opacity: 0.92;
                    line-height: 1.5;
                }

                .login-img {
                    margin-top: 28px;

                    img {
                        width: 100%;
                        display: block;
                        filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.12));
                    }
                }
            }

            .login-content {
                flex: 1;
                min-width: 0;
                padding: 40px 40px 36px;
                display: flex;
                align-items: center;
                justify-content: center;

                .login-content-inner {
                    width: 100%;
                    max-width: 360px;
                }

                .login-wel {
                    text-align: center;
                    font-size: 22px;
                    font-weight: 600;
                    color: #1a1f36;
                    position: relative;
                    padding-bottom: 14px;
                    margin-bottom: 8px;

                    &:after {
                        content: '';
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        transform: translateX(-50%);
                        width: 48px;
                        height: 3px;
                        border-radius: 2px;
                        background: linear-gradient(90deg, #3A62D7, #6b8ef0);
                    }
                }

                .login-sub {
                    text-align: center;
                    font-size: 13px;
                    color: #6b7289;
                    margin: 0 0 28px;
                }

                .login-form {
                    .el-form-item {
                        margin-bottom: 20px;
                    }
                }

                .form-item {
                    display: flex;
                    align-items: center;
                    background: #f4f6fb;
                    border-radius: 10px;
                    border: 1px solid #e8ecf4;
                    padding: 4px 4px 4px 0;
                    transition: border-color 0.2s, box-shadow 0.2s;

                    &:focus-within {
                        border-color: #3A62D7;
                        box-shadow: 0 0 0 3px rgba(58, 98, 215, 0.12);
                    }

                    .icon {
                        flex-shrink: 0;
                        padding: 0 12px 0 14px;
                        margin-right: 0;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        &:after {
                            content: '';
                            position: absolute;
                            width: 1px;
                            height: 22px;
                            top: 50%;
                            right: 0;
                            margin-top: -11px;
                            background-color: rgba(58, 98, 215, 0.25);
                        }

                        img {
                            width: 22px;
                            height: 22px;
                        }
                    }

                    .el-input {
                        flex: 1;
                    }

                    /deep/ .el-input__inner {
                        border: none;
                        background: transparent;
                        height: 44px;
                        line-height: 44px;
                        padding-left: 8px;
                    }
                }

                .formItem {
                    margin-bottom: 8px;

                    /deep/ .el-checkbox__label {
                        color: #5c6370;
                        font-size: 13px;
                    }
                }

                .login-btn {
                    width: 100%;
                    text-align: center;
                    margin-bottom: 0;
                    margin-top: 8px;

                    .login-btn-submit {
                        width: 100%;
                        height: 46px;
                        font-size: 15px;
                        font-weight: 500;
                        letter-spacing: 0.08em;
                        border-radius: 10px;
                        border: none;
                        background: linear-gradient(90deg, #3A62D7 0%, #4f74dc 100%);
                        box-shadow: 0 6px 16px rgba(58, 98, 215, 0.35);

                        &:hover {
                            background: linear-gradient(90deg, #3258c4 0%, #4568cf 100%);
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 768px) {
        .loginPage .login-main {
            flex-direction: column;
            max-width: 420px;

            .login-info {
                flex: none;
                min-width: 0;
                padding: 24px 20px;

                .login-img {
                    margin-top: 16px;
                    max-width: 240px;
                    margin-left: auto;
                    margin-right: auto;
                }
            }

            .login-content {
                padding: 28px 24px 32px;
            }
        }
    }
</style>
